//The name of this variables are always in capital letters because they are a constant and they don't change
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';

export const TIMEOUT_SEC = 10;
export const RESULT_PER_PAGE = 10;
export const START_PAGE = 1;
